import { getSubdomainInfo } from '../../services/UserService'
import { isError } from '../../utils/api'

export default {
  state: {
    hasSubdomain: false,
    exists: false,
    info: {}
  },

  mutations: {
    setHasSubdomain(state, status) {
      state.hasSubdomain = status
    },
    setSubdomainInfo(state, data) {
      state.info = data
      state.exists = true
    }
  },

  actions: {
    setHasSubdomain({ commit }, status) {
      commit('setHasSubdomain', status)
    },
    async getSubdomainInfo({ commit }, subdomain) {
      const response = await getSubdomainInfo(subdomain).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('setSubdomainInfo', response.data)
      return { success, error: response.data }
    }
  }
}
